export enum FilterMagicStyle {
  NoneStyle = 'NoneStyle',
  StyleOne = 'StyleOne',
  StyleTwo = 'StyleTwo',
}
